import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedGoogleImportStep =
  () => import(/* webpackChunkName: "google-import-step.async" */ './google-import-step')
    .then(({ GoogleImportStepWithI18n }) => GoogleImportStepWithI18n);

export const GoogleImportStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT,
  view: DelayedGoogleImportStep,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
